import _slicedToArray from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import { Wrapper, Title } from './styles';
import { formatMoney } from '@spa/shared/utils';
import { PAY_TO } from '@spa/shared/constants/payTo';
import { MONTHS } from '@spa/shared/constants/months';
import PriceLine from '@spa/shared/components/PriceLine';
import Separator from '@spa/shared/components/Unisystem/Separator';
var PriceDetails = function PriceDetails(_ref) {
  var priceDetails = _ref.priceDetails,
    hasRentCollection = _ref.hasRentCollection;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var serviceFee = priceDetails.fee.values.capped,
    holdingDeposit = priceDetails.deposit,
    firstRentPayment = priceDetails.first_payment,
    _priceDetails$rents$i = _slicedToArray(priceDetails.rents.items, 1),
    firstRent = _priceDetails$rents$i[0],
    onBooking = priceDetails.payments.on_booking;
  var hasServiceFee = serviceFee.amount > 0;
  var hasHoldingDeposit = holdingDeposit.pay_to === PAY_TO.US;
  return __jsx(Wrapper, null, __jsx(Separator, null), __jsx("h2", null, t('If and only after the landlord approves')), __jsx(Title, null, t('You\'ll pay through Uniplaces'), ":"), __jsx(PriceLine, {
    bigger: true,
    title: hasRentCollection ? t("".concat(MONTHS[firstRent.month])) : t('First rental payment'),
    description: t('Covers the first month'),
    value: formatMoney(firstRentPayment.total.amount, firstRentPayment.total.currency_code)
  }), hasServiceFee ? __jsx(PriceLine, {
    bigger: true,
    title: t('One-time service fee'),
    description: t('One time payment'),
    value: formatMoney(serviceFee.amount, serviceFee.currency_code)
  }) : null, hasHoldingDeposit ? __jsx(PriceLine, {
    bigger: true,
    title: t('Holding deposit'),
    value: formatMoney(holdingDeposit.value.amount, holdingDeposit.value.currency_code)
  }) : null, __jsx(PriceLine, {
    title: t('Total'),
    bigger: true,
    bold: true,
    value: formatMoney(onBooking.amount, onBooking.currency_code)
  }));
};
export default PriceDetails;